import { useState, useEffect } from 'react';
import {
  ModalCWShellUI,
  DescriptionUI,
} from '@next-order/next-order-components';

function ConfirmationModal({
  open,
  onCancel,
  onOpenChange,
  onConfirm,
  title = 'Are you sure?',
  description,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  destructive = false,
}) {
  const [showModal, setShowModal] = useState(open);

  useEffect(() => {
    setShowModal(open);
  }, [open]);

  const handleClose = () => {
    setShowModal(false);
    onCancel?.();
  };

  const handleConfirm = () => {
    setShowModal(false);
    onConfirm?.();
  };

  return (
    <ModalCWShellUI
      open={showModal}
      onOpenChange={onOpenChange}
      maxWidth={460}
      zIndex={9999}
      maxHeight='full'
    >
      <ModalCWShellUI.CloseButton
        onClick={handleClose}
        extendedClassName='ml-auto left-4'
      />
      <ModalCWShellUI.Header
        extendedHeadingClassName='w-full text-center text-xl md:text-2xl'
        title={title}
      />
      {description && (
        <ModalCWShellUI.Body>
          <DescriptionUI extendedClassName='text-center'>
            {description}
          </DescriptionUI>
        </ModalCWShellUI.Body>
      )}
      <ModalCWShellUI.Footer>
        <ModalCWShellUI.Button
          variant='outlined'
          onClick={handleClose}
          extendedClassName='w-full'
        >
          {cancelText}
        </ModalCWShellUI.Button>
        <ModalCWShellUI.Button
          onClick={handleConfirm}
          extendedClassName={`w-full ${
            destructive
              ? '!bg-red-500 !border-red-500 hover:!bg-red-400 hover:!border-red-400'
              : ''
          }`}
        >
          {confirmText}
        </ModalCWShellUI.Button>
      </ModalCWShellUI.Footer>
    </ModalCWShellUI>
  );
}

export default ConfirmationModal;
